import { BrowserWindow, BrowserWindowImplementation } from './window';
import { Event } from '../../events';

export default class WindowProvider {
  static currentWindow: BrowserWindow = new BrowserWindowImplementation();

  static emit(event: Event): void {
    WindowProvider.currentWindow.emit(event);
  }

  static isInIframe(): boolean {
    return WindowProvider.currentWindow.isInIframe();
  }

  static isOnDesktop(): boolean {
    return WindowProvider.currentWindow.isOnDesktop();
  }

  static href(): string {
    return WindowProvider.currentWindow.href();
  }

  static setWindow(window: BrowserWindow): void {
    WindowProvider.currentWindow = window;
  }

  static reset(): void {
    WindowProvider.currentWindow = new BrowserWindowImplementation();
  }
}
